module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seats"
  }, [_c('sk-seating', {
    attrs: {
      "cinema_id": _vm.cinema_id,
      "session_id": _vm.session_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763f6662","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/seats/seats.vue
// module id = 565
// module chunks = 0